import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";
import {
    getIsBrandPage,
    getIsCategoryPage,
    getIsReady,
    getIsSearchPage,
    getSearchQuery,
} from "@toolkit/Framework/Store/Toolkit/Pages/ProductList/ProductListSelectors";

export const useBrandName = () => {
    return useAppSelector(state => {
        const { links } = state.components.breadcrumbs;

        if (!getIsBrandPage(state) || !links) {
            return null;
        }

        return [...links].splice(-2, 1)[0]?.children?.toString();
    });
};

export const useIsBrandPage = convertSelectorToHook(getIsBrandPage);
export const useIsCategoryPage = convertSelectorToHook(getIsCategoryPage);
export const useIsReady = convertSelectorToHook(getIsReady);
export const useIsSearchPage = convertSelectorToHook(getIsSearchPage);
export const useSearchQuery = convertSelectorToHook(getSearchQuery);
export const useIsFilterNavOpen = () => useAppSelector(state => state.toolkit.pages.productList.isFilterNavOpen);
